import React from 'react';
import './PageLoader.css';

const logoSrc = require('../../pages/HomePage/msv_header_logo.png');

const PageLoader = ({ message = 'Loading…', fullHeight = true, variant = 'light' }) => (
    <div
        className={[
            'msv-page-loader',
            fullHeight ? 'msv-page-loader--fill' : '',
            variant === 'dark' ? 'msv-page-loader--dark' : '',
        ].filter(Boolean).join(' ')}
        role="status"
        aria-live="polite"
        aria-busy="true"
    >
        <div className="msv-page-loader-mark" aria-hidden="true">
            <span className="msv-page-loader-orbit msv-page-loader-orbit--outer" />
            <span className="msv-page-loader-orbit msv-page-loader-orbit--inner" />
            <span className="msv-page-loader-pulse" />
            <img src={logoSrc} alt="" className="msv-page-loader-logo" />
        </div>
        <p className="msv-page-loader-text">{message}</p>
        <span className="msv-page-loader-track" aria-hidden="true">
            <span className="msv-page-loader-dash" />
        </span>
    </div>
);

export default PageLoader;
